<template>
  <el-select v-model="modelValue" placeholder="请选择" @change="onChange">
    <el-option
      v-for="item in tableData"
      :key="item.contractLineCode"
      :label="`${item.origin}-${item.dest}`"
      :value="item.contractLineCode"
    >
      <div class="options-container">
        <div class="d-flex justify-content-between">
          <span>{{ item.origin }}</span>
          <span>{{ item.dest }}</span>
        </div>
        <div class="additional-container">
          <span class="mr-4">发货方：{{ item.originPointName }}</span>
          <span>收货方：{{ item.destPointName }}</span>
        </div>
        <div class="additional-container">
          <span>价格类型：{{ item.v_linePriceType }}</span>
          <span>订单类型：{{ item.v_orderType }}</span>
          <span>业务类型：{{ item.v_bizType }}</span>
        </div>
      </div>
    </el-option>
  </el-select>
</template>
<script>
export default {
  props: {
    contractLineCode: {
      type: String,
      default: () => '',
    },
    contractCode: String,
  },
  data() {
    return {
      modelValue: this.contractLineCode,
      tableData: [],
    }
  },
  watch: {
    modelValue(val) {
      this.$emit('change', val)
      this.$emit('update:contractLineCode', val)
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    onChange(val) {
      this.$emit('change', val)
    },
    getData() {
      if (!this.contractCode) return
      this.$api
        .contractCustomerLineSelectApi({
          contractCode: this.contractCode,
        })
        .then((res) => {
          this.tableData = res.body.data
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.options-container {
  display: flex;
  flex-direction: column;
}

.additional-container {
  font-size: 10px;
  color: #8492a6;
  display: flex;
  justify-content: space-between;
}

.el-select-dropdown__item {
  height: initial;
  margin: 15px 0;
  line-height: 20px;
}

.line-icon {
  transform: rotate(90deg);
}
</style>
